import React, { useRef, useState } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { Upload, Trash2, ImageIcon } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Miniatura + enviar/remover foto do produto (usada no Catálogo e no cadastro de Produtos)
export default function ProductPhotoUpload({ companyId, product, onChanged, size = "md" }) {
  const [photoId, setPhotoId] = useState(product.catalog_photo_id || null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const box = size === "sm" ? "w-12 h-12" : "w-20 h-20";

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await axios.post(`${API}/companies/${companyId}/factory/products/${product.id}/catalog-photo`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setPhotoId(data.photo_url.split("/").pop());
      toast.success("Foto enviada");
      onChanged && onChanged();
    } catch (e) { toast.error("Erro ao enviar foto: " + (e.response?.data?.detail || "")); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const remove = async () => {
    if (!window.confirm("Remover a foto deste produto?")) return;
    try {
      await axios.delete(`${API}/companies/${companyId}/factory/products/${product.id}/catalog-photo`);
      setPhotoId(null);
      toast.success("Foto removida");
      onChanged && onChanged();
    } catch (e) { toast.error("Erro ao remover foto"); }
  };

  return (
    <div className="flex items-center gap-2" data-testid={`product-photo-${product.id}`}>
      <div className={`${box} shrink-0 rounded border bg-gray-50 overflow-hidden flex items-center justify-center`}>
        {photoId
          ? <img src={`${API}/public/catalog-photo/${photoId}`} alt={product.name} className="w-full h-full object-contain" data-testid={`product-photo-img-${product.id}`} />
          : <ImageIcon className="h-5 w-5 text-gray-400" />}
      </div>
      <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`product-photo-input-${product.id}`} />
      <Button size="sm" variant="outline" disabled={uploading} onClick={() => fileRef.current?.click()} data-testid={`product-photo-upload-${product.id}`}>
        <Upload className="h-3 w-3 mr-1" />{uploading ? "Enviando..." : photoId ? "Trocar foto" : "Enviar foto"}
      </Button>
      {photoId && (
        <Button size="sm" variant="outline" className="text-red-600" onClick={remove} data-testid={`product-photo-remove-${product.id}`}><Trash2 className="h-3 w-3" /></Button>
      )}
    </div>
  );
}
